import { array, object, ObjectSchema, string } from 'yup';

import { CustomerStatusDto } from '@/api/generated';
import {
  selectSearchOptionRequiredFieldsValidation,
  selectSearchOptionRequiredValidation,
} from '@/utils/form/selectSearchOptionOptional.validation.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix';
import { CustomerSearchFormModel } from '@/views/customers/list/model/CustomersSearchForm.model.ts';

export const useCustomersFormValidation = (): ObjectSchema<CustomerSearchFormModel> => {
  const { t } = useTranslationWithPrefix('validation');

  return object().shape({
    fullTextSearchInput: string()
      .min(3, t('minLength', { min: 3 }))
      .transform((value, originalValue) => (originalValue === '' ? undefined : value)),
    ownerIdOfCustomerContact: selectSearchOptionRequiredFieldsValidation<string>(
      string(),
      t,
    ).nullable(),
    // tables stored before the status filter existed have no statuses
    statuses: array()
      .of(selectSearchOptionRequiredValidation<CustomerStatusDto>(string(), t))
      .default([])
      .required(),
  });
};
